import axios from 'axios';
// Next we make an 'instance' of it
// const AxiosCustomConfig = axios.create({
// // .. where we make our configurations
//     baseURL: 'http://192.168.0.106/transactiapi'
// });

// // Where you would set stuff like your 'Authorization' header, etc ...
// AxiosCustomConfig.defaults.headers.common['Authorization'] = 'AUTH TOKEN FROM INSTANCE';
// console.log("testttttttttttttttt")

export const AxiosCustomConfig  = function(){
    axios.defaults.baseURL = 'http://192.168.0.106/transactiapi';
    axios.defaults.headers.common['Authorization'] ='12';
    axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
}